import { render, staticRenderFns } from "./_change-password.vue?vue&type=template&id=251f9f25&"
import script from "./_change-password.vue?vue&type=script&lang=js&"
export * from "./_change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports